import { render, staticRenderFns } from "./WarningIcon.vue?vue&type=template&id=20306560&scoped=true"
import script from "./WarningIcon.vue?vue&type=script&lang=js"
export * from "./WarningIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20306560",
  null
  
)

export default component.exports